import { Seo } from "@/components/site/Seo";
import { Star, Squiggle } from "@/components/site/Doodles";

export const AuthShell = ({ title, subtitle, children, testId }) => (
  <section className="km-grid-bg relative overflow-hidden" data-testid={testId}>
    <Seo title={title} noindex />
    <Star className="km-float absolute left-[8%] top-16 h-10 w-10" />
    <div className="relative mx-auto max-w-md px-4 py-16 sm:py-24">
      <h1 className="font-display text-4xl text-white sm:text-5xl">
        <span className="relative inline-block">{title}<Squiggle className="absolute -bottom-3 right-0 h-4 w-full" color="#E9D8FF" /></span>
      </h1>
      {subtitle && <p className="mt-6 text-purple-200/85">{subtitle}</p>}
      <div className="mt-8 rounded-[2rem] border border-purple-500/25 bg-[var(--km-bg2)]/90 p-6 shadow-[0_30px_80px_rgba(0,0,0,0.5)] sm:p-8">{children}</div>
    </div>
  </section>
);

export const FormError = ({ msg }) =>
  msg ? <p className="rounded-xl bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="auth-error">{msg}</p> : null;
